goog.provide("shadow.js.shim.module$$mui$material$CardActionArea");
goog.provide("module$shadow_js_shim_module$$mui$material$CardActionArea");
shadow.js.shim.module$$mui$material$CardActionArea = shadow.js.nativeProvides["@mui/material/CardActionArea"] = shadow$bridge("@mui/material/CardActionArea");
module$shadow_js_shim_module$$mui$material$CardActionArea.default = shadow.js.shim.module$$mui$material$CardActionArea;
